import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
(
    <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
    </Suspense>
);

// Dashboards

const DashboardSupervisor = Loader(
    lazy(() => import('src/content/supervisor/Dashboard'))
);

const Events = Loader(lazy(() => import('src/content/supervisor/Event')));
const Assigments = Loader(lazy(() => import('src/content/supervisor/Assigment')));
const Report = Loader(lazy(() => import('src/content/supervisor/Reports')));
const Notification = Loader(lazy(() => import('src/content/supervisor/Notification')));

const supervisorRoutes = [
    {
        path: '/',
        element: <Navigate to="dashboard" replace />
    },
    {
        path: 'dashboard',
        element: <DashboardSupervisor />
    },
    {
        path: 'events',
        element: <Events />
    },
    {
        path: 'reports',
        element: <Report />
    },
    {
        path: 'assignments',
        element: <Assigments />
    },
    {
        path: 'notifications',
        element: <Notification />
    },
];

export default supervisorRoutes;
